import useCategories from "./useCategories"
import useCart from "./useCart";

export default function useCategory(){

    const categoriesQuery = useCategories();

    const categories = categoriesQuery.isSuccess ? categoriesQuery.data : [];

    const { cart } = useCart();

    if( !cart.category ) return null;

    return categories.find(cat => cat.id === cart.category) || null;
}